import { Modal, Form, Input, Button, Col, Row, notification, Radio, DatePicker } from 'antd';
import { useEffect } from 'react';
import store from '../../../../../controllers/store';
import { useSelector } from 'react-redux';
import { update } from '../../../../../controllers/store/actions/groups/update-groups-actions';
import SelectCities from '../../Elements/Select-Cities';
import SelectKnowledgeArea from '../../Elements/Select-Knowledge-Area';
import SelectKnowledgeSpecialty from '../../Elements/Select-Knowledge-Specialty';
import SelectKnowledgeGran from '../../Elements/Select-Knowledge-Gran';
import TextArea from 'antd/es/input/TextArea';
import SelectRecognition from '../../Elements/Select-Recognize';
import dayjs from "dayjs";
import SelectUniversity from '../../Elements/Select-University';

interface Props {
    loading?: boolean,
    visible: boolean,
    group?: any,
    onUpdated: () => void
    onCancel: () => void,
}
const dispatch = store.dispatch;

const UpdateGroupModal = (Props: Props) => {
    const [form] = Form.useForm();
    const [api, contextHolder] = notification.useNotification();
    const updatedGroup = useSelector((state: any) => state.updatedGroup);

    useEffect(() => {
        form.setFieldsValue({
            ...Props.group,
            update_date: dayjs(Props.group?.update_date),
            issue_date: dayjs(Props.group?.issue_date),
            current_date: dayjs(Props.group?.current_date),
            city: { value: parseFloat(Props.group?.city) },
            nme_gran_area_gr: Props.group?.nme_gran_area_gr?.id,
            nme_area_gr: Props.group?.nme_area_gr?.id,
            nme_area_esp_gr: Props.group?.nme_area_esp_gr?.id,
            universities :  Props?.group?.universities?.map((e: any) => ({ value : e.universities_id})),
            codigo_institucion: Props?.group?.codigo_institucion?.map((e: any) => e.universities_id)
        });
    }, [form, Props.group]);

    return (
        <Modal
            visible={Props.visible}
            width={800}
            title={'Grupo de investigación'}
            okText={'Modificar grupo de investigación'}
            cancelText="Cancelar"
            footer={null}
            onCancel={Props.onCancel}
        >
            <>
                {contextHolder}
                <Form
                    form={form}
                    layout="vertical"
                    onFinish={async (values: any) => {
                        form.validateFields().then(async (data: any) => {
                            await dispatch(update(Props.group.id, {
                                contact_name: values.contact_name,
                                contact_email: values.contact_email,
                                nme_clasificacion_gr: values.nme_clasificacion_gr,
                                nme_municipio_gr: values.city.value,
                                nme_gran_area_gr: values.nme_gran_area_gr,
                                nme_area_gr: values.nme_area_gr,
                                nme_area_esp_gr: values.nme_area_esp_gr,
                                cod_grupo_gr: values.cod_grupo_gr,
                                nme_grupo_gr: values.nme_grupo_gr,
                                description: values.description,
                                recognized_min: values.recognized_min.value,
                                update_date: new Date(values.update_date).toISOString(),
                                issue_date: new Date(values.issue_date).toISOString(),
                                current_date: new Date(values.current_date).toISOString(),
                                features: values.features,
                                source: values.source,
                                city: values?.city.value,
                                url: values.url,
                                universities : values.universities.map((e: any) => ({ universities_id: e.value })),
                                codigo_institucion: []
                            }));
                            Props.onUpdated()
                        })
                    }}
                    name="updateGroup"
                >
                    <Row gutter={[8, 8]} style={{ width: '100%', marginTop: 30 }}>
                        <Col xs={24} sm={12} md={8} lg={18}>
                            <Form.Item
                                label="Grupo"
                                name="nme_grupo_gr"
                                rules={[
                                    { required: true, message: 'Por favor ingrese el nombre del grupo' },
                                ]}
                            >
                                <Input />
                            </Form.Item>
                        </Col>
                        <Col xs={24} sm={12} md={8} lg={6}>
                            <Form.Item
                                label="Código de grupo"
                                name="cod_grupo_gr"
                                rules={[
                                    { type: 'string', message: 'Por favor ingrese el código del grupo' },
                                ]}
                            >
                                <Input />
                            </Form.Item>
                        </Col>
                        <Col xs={24} sm={12} md={8} lg={24}>
                            <Form.Item
                                label="Descripción"
                                name="description"
                                rules={[
                                    { type: 'string' },
                                ]}
                            >
                                <Input.TextArea />
                            </Form.Item>
                        </Col>
                        <Col xs={24} sm={12} md={8} lg={12}>
                            <Form.Item
                                label="Nombre de contacto"
                                name="contact_name"
                                rules={[
                                    { required: true, message: 'Por favor ingrese el nombre de contacto' },
                                ]}
                            >
                                <Input />
                            </Form.Item>
                        </Col>
                        <Col xs={24} sm={12} md={8} lg={12}>
                            <Form.Item
                                label="Email de contacto"
                                name="contact_email"
                                rules={[
                                    { required: true, message: 'Por favor ingrese el email de contacto' },
                                    { type: 'email', message: 'Por favor ingrese un email válido' },
                                ]}
                            >
                                <Input />
                            </Form.Item>
                        </Col>
                        <Col xs={24} sm={12} md={8} lg={24}>
                            <Form.Item
                                label="Institución"
                                name="universities"
                                rules={[
                                    { type: 'array' },
                                ]}
                            >
                                <SelectUniversity
                                    onClear={() => {

                                    }}
                                    mode={'multiple'}
                                    style={{ width: '100%' }}
                                    size="large"
                                    onChange={(selected: any) => {
                                        form.setFieldValue('universities', selected);
                                    }}
                                />
                            </Form.Item>
                        </Col>
                        <Col xs={24} sm={12} md={8} lg={12}>
                            <Form.Item
                                label="Clasificación"
                                name="nme_clasificacion_gr"
                                rules={[
                                    { type: 'string' },
                                ]}
                            >
                                <Input />
                            </Form.Item>
                        </Col>
                        <Col xs={24} sm={12} md={6} lg={12}>
                            <Form.Item
                                label="Ciudad"
                                name="city"
                            >
                                <SelectCities style={{ width: '100%' }} size="large"
                                    defaultValue='Ciudad'
                                    onChange={async (selected: any) => {
                                        form.setFieldValue('city', selected);
                                        await form.validateFields();
                                    }}
                                    onClear={() => {

                                    }}
                                />
                            </Form.Item>

                        </Col>
                        <Col xs={24} sm={12} md={8} lg={8}>
                            <Form.Item
                                label="Area general"
                                name="nme_area_gr"
                                initialValue={Props?.group?.nme_area_gr}
                                rules={[
                                    { type: 'number', required: true, message: "El campo es obligatorio" },
                                ]}
                            >
                                <SelectKnowledgeArea
                                    onClear={() => {

                                    }}
                                    style={{ width: '100%' }}
                                    size="large"
                                    onChange={async (selected: any) => {
                                        if (selected) {
                                            form.setFieldValue('nme_area_pr', selected.value);
                                            await form.validateFields();
                                        }
                                    }} />
                            </Form.Item>
                        </Col>
                        <Col xs={24} sm={12} md={8} lg={8}>
                            <Form.Item
                                label="Área específica"
                                name="nme_area_esp_gr"
                                initialValue={Props?.group?.nme_area_esp_gr}
                                rules={[
                                    { type: 'number', required: true, message: "El campo es obligatorio" },
                                ]}
                            >
                                <SelectKnowledgeSpecialty
                                    onClear={() => {
                                    }}
                                    size="large"
                                    onChange={async (selected: any) => {
                                        if (selected) {
                                            form.setFieldValue('nme_area_esp_gr', selected.value);
                                            await form.validateFields();
                                        }
                                    }} />
                            </Form.Item>
                        </Col>
                        <Col xs={24} sm={12} md={8} lg={8}>
                            <Form.Item
                                label="Gran área del conocimiento"
                                name="nme_gran_area_gr"
                                initialValue={Props?.group?.nme_gran_area_pr}
                                rules={[
                                    { type: 'number', required: true, message: "El campo es obligatorio" },
                                ]}
                            >
                                <SelectKnowledgeGran
                                    onClear={() => { }}
                                    style={{ width: '100%' }}
                                    size="large"
                                    onChange={async (selected: any) => {
                                        if (selected) {
                                            form.setFieldValue('nme_gran_area_gr', selected.value);
                                            await form.validateFields();
                                        }
                                    }} />
                            </Form.Item>
                        </Col>
                        <Col xs={24} sm={12} md={6} lg={12}>
                            <Form.Item
                                label="Reconocimiento MinCiencia"
                                name="recognized_min"
                                rules={[
                                    { type: 'number', required: true, message: "El campo es obligatorio" },
                                ]}
                            >
                                <SelectRecognition
                                    onClear={() => { }}
                                    size="large"
                                    onChange={async (selected: any) => {
                                        form.setFieldValue('recognized_min', selected);
                                        await form.validateFields();
                                    }} />
                            </Form.Item>
                        </Col>
                        <Col xs={24} sm={12} md={8} lg={12}>
                            <Form.Item
                                label="Fuente"
                                name="source"
                                rules={[
                                    { type: 'string', required: true, message: "El campo es obligatorio" }
                                ]}
                            >
                                <Input />
                            </Form.Item>
                        </Col>
                        <Col xs={24} sm={12} md={8} lg={24}>
                            <Form.Item
                                label="Características"
                                name="features"
                                rules={[
                                    { type: 'string' },
                                ]}
                            >
                                <TextArea rows={4} />
                            </Form.Item>
                        </Col>
                        <Col xs={24} sm={12} md={8} lg={8}>
                            <Form.Item
                                label="Fecha de expedición"
                                name="issue_date"
                                rules={[
                                    { type: 'object', required: true, message: "Ingrese una fecha valida" },
                                ]}
                            >
                                <DatePicker
                                    placeholder='Fecha de expedición'
                                    format={'YYYY-MM-DD'}
                                    onChange={(date, dateString) => form.setFieldValue('issue_date', date)}
                                    style={{ width: '100%' }}
                                    size='large' />
                            </Form.Item>
                        </Col>
                        <Col xs={24} sm={12} md={8} lg={8}>
                            <Form.Item
                                label="Vigencia"
                                name="current_date"
                                rules={[
                                    { type: 'object', required: true, message: "Ingrese una fecha valida" },
                                ]}
                            >
                                <DatePicker
                                    format={'YYYY-MM-DD'}
                                    onChange={(date, dateString) => form.setFieldValue('current_date', date)}
                                    style={{ width: '100%' }}
                                    size='large'
                                    placeholder='Vigencia'
                                />
                            </Form.Item>
                        </Col>
                        <Col xs={24} sm={12} md={8} lg={8}>
                            <Form.Item
                                label="Última actualización"
                                name="update_date"
                                rules={[
                                    { type: 'object', required: true, message: "Ingrese una fecha valida" },
                                ]}
                            >
                                <DatePicker
                                    format={'YYYY-MM-DD'}
                                    onChange={(date, dateString) => form.setFieldValue('update_date', date)}
                                    style={{ width: '100%' }}
                                    size='large'
                                    placeholder='Última actualización'
                                />
                            </Form.Item>
                        </Col>
                    </Row>
                    <Form.Item wrapperCol={{ span: 24 }}>
                        <Button
                            loading={updatedGroup?.isLoading}
                            type="primary"
                            size={"large"}
                            block
                            htmlType="submit"
                        >
                            Modificar grupo
                        </Button>
                    </Form.Item>
                </Form >
            </>
        </Modal >
    )
}
    ;


export default UpdateGroupModal;